import utils from '@eitje/utils'
import {config} from '../config'
import {afterIndex} from './helpers'
import {getIndexScope} from './index_scope'

export const buildIndexParams = ({name, filters = {}, inverted, refresh, prunable, params = {}, includeRelatedItems = true}) => {
	const {
		scope,
		stampParams = {},
		currentIds = [],
		relatedItems = [],
		unscopedItems = [],
	} = getIndexScope({name, filters, inverted, refresh, prunable})

	const conditionalParams = {}

	if (utils.exists(filters)) {
		conditionalParams.filters = filters
	}

	const requestParams = {
		...params,
		...stampParams,
		...conditionalParams,
		action_version: getActionVersion(name),
		direction: inverted && 'older',
	}

	if (!refresh) {
		requestParams.currentIds = currentIds
		if (includeRelatedItems && utils.exists(relatedItems)) requestParams.relatedItems = relatedItems
		if (utils.exists(unscopedItems)) requestParams.unscopedItems = unscopedItems
	}

	return {scope, requestParams}
}

export const normalizeIndexResponse = ({scope, refresh, responseData = {}}) => {
	const {items = [], action_version, destroyed_ids = [], invalidated_unscoped_ids = [], removed_from_scope_ids = []} = responseData
	const mappedItems = afterIndex({scopeId: scope.id, items})
	const force = responseData.force || refresh
	const lastUpdatedStamp = config.stampFields[scope.kind] ? null : getLastUpdatedStamp({scope, items, force})
	const shouldUpdate =
		items.length > 0 || force || destroyed_ids.length > 0 || invalidated_unscoped_ids.length > 0 || removed_from_scope_ids.length > 0
	if (!shouldUpdate) return null

	return {
		items: mappedItems,
		force,
		destroyedIds: [...destroyed_ids, ...invalidated_unscoped_ids],
		removedFromScopeIds: removed_from_scope_ids,
		actionVersion: action_version,
		scope: {...scope, ...(lastUpdatedStamp && {lastUpdatedStamp}), fetchedAt: new Date().toISOString()},
	}
}

const getLastUpdatedStamp = ({scope, items, force}) => {
	const responseStamp = utils.getMax(items)?.updated_at
	if (force) return responseStamp

	const storedStamp = config.store.getState().records.scopes[scope.id]?.lastUpdatedStamp
	if (!responseStamp) return storedStamp
	if (!storedStamp) return responseStamp
	return storedStamp > responseStamp ? storedStamp : responseStamp
}

const getActionVersion = kind => {
	const state = config.store.getState()
	return state.records.actionVersions?.[kind]
}
